import { signOut } from "aws-amplify/auth";
import ClienteFixSideHome from "../layout/ClientFixSideHome";
import AnalistFixSideHome from "../layout/AnalistFixSideHome";
import AdminFixSideHome from "../layout/AdminFixSideHome";
import { useUserStore } from "../store/userStore";

const LayoutFixHome = ({ children }: { children: React.ReactNode }) => {
  const profile = useUserStore((state) => state.profile);
  const handleLogout = async () => {
    try {
      await signOut();
      useUserStore.getState().clearUserData();
      console.log("Usuário deslogado com sucesso");
      window.location.href = "/login";
    } catch (error) {
      console.error("Erro ao deslogar:", error);
    }
  };

  return (
    <div>
      {profile[0] === "cliente" && (
        <ClienteFixSideHome handleLogout={handleLogout}>
          {children}
        </ClienteFixSideHome>
      )}
      {profile[0] === "analista" && (
        <AnalistFixSideHome handleLogout={handleLogout}>
          {children}
        </AnalistFixSideHome>
      )}
      {profile[0] === "admin" && (
        <AdminFixSideHome handleLogout={handleLogout}>
          {children}
        </AdminFixSideHome>
      )}
    </div>
  );
};

export default LayoutFixHome;
